/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : fileHandlingActions.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";
import useAxios from "../../hooks/useAxios";
import { toast } from "react-toastify";
import customConsole from "../../config/customConsole";
export const AddFilesOrImage = (uploadedFile) => {
  const httpStatus = {
    SUCCESS: 200,
    BAD_REQUEST: 400,
  };
  const file = new FormData();
  customConsole(uploadedFile);
  file.append("name", "filename");
  file.append("filename", uploadedFile);
  let error = "";
  const api = useAxios();
  return async (dispatch) => {
    const response = await api.post(`/UCM/files/upload`, file).catch((e) => {
      error = e;
      customConsole(`Error: ${e}`);
    });
    if (response?.status === httpStatus.SUCCESS) {
      customConsole(
        `response.status: ${response.status}, ${JSON.stringify(response)}`
      );
      dispatch({
        type: actionType.ADD_FILE,
        payload: { data: response.data, statusFlag: true },
      });
      toast.success("Successfully Uploaded", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (error?.message?.includes("400")) {
      customConsole("Bad Request Error: " + error);
    } else {
      customConsole("Unhandled Error: " + error);
    }
  };
};

export const GetFilesOrImage = (filename) => {
  const url = "https://dhpreprod.neubinary.com";
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) {
    return async (dispatch) => {
      await fetch(`${url}/UCM/files/details${filename}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            const imageDataUrl = reader.result;
            dispatch({
              type: actionType.GET_FILES,
              payload: imageDataUrl,
            });
          };
          reader.readAsDataURL(blob);
        })

        .catch((error) => {
          customConsole("getFiles Action Error : " + error);
        });
    };
  }
};
